import { useState } from 'react';

export const useChatView = () => {
  const [isOpenChat, setIsChatOpen] = useState(false);
  const togleChatView = () => {
    setIsChatOpen((prev) => !prev);
  };
  return { isOpenChat, togleChatView };
};
